<template>
  <div class="editor-slider__parent-flex text-container">
    <div class="editor-slider__wrapper editor-wrapper">
      <ClientOnly>
        <div>
          <Swiper
            class="editor-slider"
            :slides-per-view="1"
            :space-between="0"
            :auto-height="true"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(item, index) in images"
              :key="index"
              class="swiper-slide"
            >
              <EditorImageSliderCard
                :image-src="item.src"
                :description="item.description"
                :source="item.source"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </ClientOnly>
      <EditorImageSliderControl
        type="prev"
        class="editor-slider__prev"
        :class="isBeginning ? 'editor-slider__lock' : 'editor-slider__avalbl'"
        @click="slidePrev()"
      />
      <EditorImageSliderControl
        type="next"
        class="editor-slider__next"
        :class="isEnd ? 'editor-slider__lock' : 'editor-slider__avalbl'"
        @click="slideNext()"
      />
      <EditorImageSliderPaginationCount
        :total="images.length"
        class="editor-slider__pagination-count"
        :current="currentSlideIndex + 1"
      />
      <template v-if="editable">
        <EditorImageSliderEdit
          class="main-slider-edit"
          @edit="openSettings"
          @delete="handleDelete"
        />
        <EditorImageSliderSettingsModal
          v-if="isSettingsModalShowed"
          :images="images"
          @save="handleSaveSettings"
          @close="closeSettings"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps({
  editable: { type: Boolean, default: false },
  images: { type: Array, required: true },
});
const emit = defineEmits(['delete', 'change']);

const { onSwiper, slideNext, slidePrev, isBeginning, isEnd, activeIndex } =
  useSwiper();

const isSettingsModalShowed = ref(false);
const currentSlideIndex = computed(() => activeIndex.value);

const openSettings = () => {
  isSettingsModalShowed.value = true;
};

const closeSettings = () => {
  isSettingsModalShowed.value = false;
};

const handleDelete = () => {
  emit('delete');
};

const handleSaveSettings = (data) => {
  emit('change', data);
  closeSettings();
};
</script>
